const LAYOUT_TYPE = {
  horizontal: 'horizontal',
  vertical: 'vertical'
}

export { LAYOUT_TYPE }
